import { render, staticRenderFns } from "./NotificationDialog.vue?vue&type=template&id=d6284c44&scoped=true&"
import script from "./NotificationDialog.vue?vue&type=script&lang=ts&"
export * from "./NotificationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationDialog.vue?vue&type=style&index=0&id=d6284c44&prod&lang=less&"
import style1 from "./NotificationDialog.vue?vue&type=style&index=1&id=d6284c44&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6284c44",
  null
  
)

export default component.exports